import isCsairApp from './isCsairApp';
/**
 * 保存本地数据
 * @param {string} key
 * @param data
 */
export function saveLocalData(key, data) {
    var _a;
    if (isCsairApp()) {
        window.CSNativeObject.saveDataLocalStorage(JSON.stringify((_a = {}, _a[key] = data, _a)));
    }
    else {
        localStorage.setItem(key, JSON.stringify(data));
    }
}
/**
 * 获取本地数据
 * @param {string} key
 * @returns
 */
export function getLocalData(key) {
    var data = null;
    if (isCsairApp()) {
        data = window.CSNativeObject.getDataLocalStorage(JSON.stringify({ keyName: key }));
    }
    else {
        data = localStorage.getItem(key);
    }
    try {
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
    }
    catch (error) {
        data = null;
    }
    return data;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/appLocalStorge.js
// module id = null
// module chunks = 